"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleReportFor5ystemType = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.toggleReportFor5ystemType = (0, graphql_tag_1.default) `
  mutation ToggleReportFor5ystemType($reportInfo: ReportInputType!) {
    toggleReportsForsystemType(reportInfo: $reportInfo) {
      id
      reportSettings {
        systemType
        reports {
          reportId
          reportSettingParams {
            paramName
            value
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=toggle-report-for-systemType.js.map